import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Multiplication from './Multiplication';
import Division from './Division';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter, Route, Routes} from "react-router-dom";

import App from "./App"
import Quiz from "./components/Quiz"
import Quiz2 from "./components/Quiz2"

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <Routes>

                <Route path={'/'} element={<App/>}></Route>
                <Route path={'/m'} element={<Multiplication/>}></Route>
                <Route path={'/d'} element={<Division/>}></Route>
                <Route path={'/q'} element={<Quiz/>}></Route>
                <Route path={'/q2'} element={<Quiz2/>}></Route>
            </Routes>
        </BrowserRouter>


        {/*<ul>*/}
        {/*    <li><Link to={"/d"}>Division</Link></li>*/}
        {/*    <li><Link to={"/m"}>Multiplication</Link></li>*/}
        {/*</ul>*/}


    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
